import { Swiper } from 'swiper';
import { SwiperOptions } from 'swiper/types';
import { classInstance } from '@/shared/helpers/helpers';
import { Controller } from 'swiper/modules';

export class MainCollectionsCollection {
	private readonly element: HTMLElement;
	public slider: Swiper;

	private sliderSettings = (): SwiperOptions => ({
		modules: [Controller],
		slidesPerView: 1,
	});


	constructor(element) {
		if (!element) return;
		this.element = element;
		this.init();
	}

	public init = (): void => {
		this.slider = new Swiper(this.element, this.sliderSettings());
		classInstance.set(this.element, this);
	};

	public destroy = (): void => {
		classInstance.del(this, 'MainCollectionsContent');
		this.slider.destroy();
		this.slider = null;
	};

	public setDoctors = (swiper): void => {
		this.slider.controller.control = swiper;
	};
}
